import { matchPath } from "react-router-dom";
import LicenseServerRoutes from "routes";

export const routeExists = (pattern: string): boolean => {
	for (const route in LicenseServerRoutes) {
        if (Object.prototype.hasOwnProperty.call(LicenseServerRoutes, route)) {
            const value = (LicenseServerRoutes as any)[route];
            if (pattern !== LicenseServerRoutes.Root && matchPath(pattern, value)) {
                return true;
            }
        }
	}

	return false;
};
